exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-breadcrumbs {\n  width: 100%;\n}\n.filter-breadcrumbs .label {\n  font-weight: 400;\n  font-size: 12px;\n  padding: 0.5em 0.7em;\n  display: inline-block;\n  margin-bottom: 0.5em;\n}\n.filter-breadcrumbs i:hover {\n  cursor: pointer;\n}", ""]);

// exports
